import QuestionnaireForm from 'app/features/questionnaires/components/QuestionnaireForm';
import { useSelector } from 'react-redux';
import { useValidateQuestionnaireForm } from '../../../useValidateQuestionnaire';
import { fields, validationSchema } from './fields';
import { selectHousingArrangements } from './slice';

export interface IHousingArrangementsProps {}

export function useValidateHousingArrangements() {
  const { values } = useSelector(selectHousingArrangements);

  return useValidateQuestionnaireForm(
    'personal_details.where_i_live.housing_arrangements',
    values,
    validationSchema,
  );
}
export default function HousingArrangements(props: IHousingArrangementsProps) {
  const initialState = useSelector(selectHousingArrangements);

  return (
    <QuestionnaireForm
      defautlValues={initialState.values}
      fields={fields}
      validationSchema={validationSchema}
      className="md-max:grid md-max:grid-cols-4 md-max:gap-y-4"
      fieldClassName="md-max:col-span-4"
    />
  );
}
